import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import React from 'react';
import { AlertDialogProvider } from '../alert-dialog-provider';
import { TooltipProvider } from '../tooltip';

export type TappProviderProps = { children: React.ReactNode };

export const TappProvider: React.FC<TappProviderProps> = ({ children }) => {
  const cache = React.useMemo(
    () =>
      createCache({
        key: 'with-tailwind',
        insertionPoint: document.querySelector('title')!,
      }),
    []
  );

  return (
    <CacheProvider value={cache}>
      <AlertDialogProvider>
        <TooltipProvider delayDuration={500}>{children}</TooltipProvider>
      </AlertDialogProvider>
    </CacheProvider>
  );
};
